import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons';
import { Container, Row, Col } from 'react-bootstrap';
import { useI18n } from '../../i18n/i18n';
import { API_BASE, getCoverUrl } from '../../config';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

const LatestServicesPart = () => {
  const [houses, setHouses] = useState([]);
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const { t } = useI18n();

  // 加载首页指定展示的房源
  useEffect(() => {
    const fetchHouses = async () => {
      try {
        const response = await fetch(`${API_BASE}/api/houses`);
        const data = await response.json();
        // 首页固定展示这3个房源，按指定顺序排列
        const featuredFolders = ['Rita Hotel Namba', 'プラウドタワー神戸垂水', 'ワコーレヴィータ塚口'];
        const featured = featuredFolders
          .map(folder => data.find(h => h.folder_name === folder))
          .filter(Boolean);
        setHouses(featured.map(h => ({ ...h, folderName: h.folder_name })));
      } catch (e) {
        console.error('Error loading houses:', e);
      } finally {
        setLoading(false);
      }
    };
    fetchHouses();
  }, []);

  // 样式定义
  const styles = {
    singleService: {
      marginTop: '30px',
      marginBottom: '55px',
      overflow: 'hidden',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',  // 确保服务卡片的高度一致
    },
    imgContainer: {
      width: '100%',
      height: '250px', // 固定图片容器的高度
      overflow: 'hidden', // 确保图片超出部分被裁剪
    },
    img: {
      width: '100%',
      height: '100%',
      objectFit: 'cover', // 图片填充容器，保持比例，可能会裁剪图片
      transition: 'transform 0.5s ease',
    },
    content: {
      padding: '20px',
      backgroundColor: '#fff',
      boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.1)',
      flexGrow: 1, // 使内容部分占用剩余空间，确保按钮在底部
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    title: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      marginBottom: '10px',
    },
    description: {
      fontSize: '1rem',
      color: '#555',
      marginBottom: '10px',
    },
    linkContainer: {
      textAlign: 'left',
      marginTop: 'auto', // 将按钮推到内容部分的底部
    },
    link: {
      color: '#333',
      textDecoration: 'none',
    },
    arrowIcon: {
      marginLeft: '5px',
    },
  };

  return (
      <React.Fragment>
        <div className="services-title-area">
          <Container>
            <Row className="justify-content-center">
              <Col lg="12">
                <div className="services-title-item text-center">
                  <div className="ring-shape" />
                  <span>{t('home.services.subtitle', '推荐房源')}</span>
                  <h3 className="title">{t('home.services.title.line1', '核心地带 or 品质住宅')}<br /> {t('home.services.title.line2', '样样精通')}</h3>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="latest-services-area">
          <Container>
            <Row className="justify-content-center">
              {loading ? <LoadingSpinner text={t('common.loading')} height="200px" /> : houses.map((house, index) => (
                  <div className="col-lg-4 col-md-6 col-sm-9" key={index}>
                    <div className="single-services" style={{ ...styles.singleService, cursor: 'pointer' }} onClick={() => history.push(`/house-details/${house.folderName}`)}>
                      {/* 使用房源的封面图片 */}
                      <div className="services-thumb" style={styles.imgContainer}>
<img src={getCoverUrl(house)} alt={house.title} style={styles.img} />
                      </div>
                      <div className="services-content" style={styles.content}>
                        <h4 className="title" style={styles.title}>{house.title}</h4>
                        <p style={styles.description}>{house.description}</p>
                        <div style={styles.linkContainer}>
                          <span style={styles.link}>
                            {t('home.services.cta', '了解更多')}
                            <FontAwesomeIcon icon={faLongArrowAltRight} style={styles.arrowIcon} />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
              ))}
            </Row>
          </Container>
        </div>
      </React.Fragment>
  );
};

export default LatestServicesPart;